// extracted by mini-css-extract-plugin
export default {"spaceMembers":"space-members_spaceMembers__dJU-r","stats":"space-members_stats__B4Zge","circles":"space-members_circles__Er1rt","text":"space-members_text__Pq495"};